import { type LWApiPublicSupportRequestMigrationStatusPicklistOptionsResultRaw } from '@liquidweb-dev/club-sauce/public/support/request/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import api from 'modules/queries/api';

export const SUPPORT_REQUEST_MIGRATION_STATUS_LIST_OPTIONS_QUERY_KEY =
	'/support/request/migrationStatusPicklistOptions';

const useSupportRequestMigrationStatusListOptions = (
	options?: UseQueryOptions<
		LWApiPublicSupportRequestMigrationStatusPicklistOptionsResultRaw,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [SUPPORT_REQUEST_MIGRATION_STATUS_LIST_OPTIONS_QUERY_KEY],
		queryFn: () => api.support.request.apiRaw.migrationStatusPicklistOptions(),
		...options,
	});

export default useSupportRequestMigrationStatusListOptions;
